import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import { Intersect } from 'vuetify/lib/directives';
// import 'vuetify/dist/vuetify.min.css';

import FiveIcon from '@/components/icons/5'
import NineIcon from '@/components/icons/9'
import TwentyFourIcon from '@/components/icons/24'
import FortyEightIcon from '@/components/icons/48'
import ArrowDownIcon from '@/components/icons/Arrow-down'
import ArrowUpIcon from '@/components/icons/Arrow-up'
import AutonomousIcon from '@/components/icons/Autonomous'
import BrightnessIcon from '@/components/icons/Brightness'
import CarIcon from '@/components/icons/Car'
import CarDangerIcon from '@/components/icons/Car-danger'
import CarPartialIcon from '@/components/icons/Car-partial'
import CheckIcon from '@/components/icons/Check'
import ChevroletIcon from '@/components/icons/Chevrolet'
import ChevronDownIcon from '@/components/icons/Chevron-down'
import ChevronLeftIcon from '@/components/icons/Chevron-left'
import ChevronLeftFilledIcon from '@/components/icons/Chevron-left-filled'
import ChevronRightIcon from '@/components/icons/Chevron-right'
import ChevronRightFilledIcon from '@/components/icons/Chevron-right-filled'
import ChevronUpIcon from '@/components/icons/Chevron-up'
import Clipboard from '@/components/icons/Clipboard'
import ColorSwatchIcon from '@/components/icons/Color-swatch'
import CompareIcon from '@/components/icons/Compare'
import ComparisonIcon from '@/components/icons/Comparison'
import ContrastIcon from '@/components/icons/Contrast'
import CropIcon from '@/components/icons/Crop'
import DangerIcon from '@/components/icons/Danger'
import DownloadIcon from '@/components/icons/Download'
import EditIcon from '@/components/icons/Edit'
import EyeIcon from '@/components/icons/Eye'
import EyeCloseIcon from '@/components/icons/Eye-close'
import FlagIcon from '@/components/icons/Flag'
import FloppyIcon from '@/components/icons/Floppy'
import FordIcon from '@/components/icons/Ford'
import LinkIcon from '@/components/icons/Link'
import MessageIcon from '@/components/icons/Message'
import MinusIcon from '@/components/icons/Minus'
import MoreIcon from '@/components/icons/More'
import NextIcon from '@/components/icons/Next'
import OpenWindowIcon from '@/components/icons/Open-window'
import PencilIcon from '@/components/icons/Pencil'
import PictureIcon from '@/components/icons/Picture'
import PlusIcon from '@/components/icons/Plus'
import RaceIcon from '@/components/icons/Race'
import RefreshIcon from '@/components/icons/Refresh'
import RefreshTwoIcon from '@/components/icons/Refresh2'
import ReportIcon from '@/components/icons/Report'
import RotateIcon from '@/components/icons/Rotate'
import SaveIcon from '@/components/icons/Save'
import SearchIcon from '@/components/icons/Search'
import SettingsIcon from '@/components/icons/Settings'
import ShapeArrowIcon from '@/components/icons/Shape-arrow'
import ShapeDotIcon from '@/components/icons/Shape-dot'
import ShapeEllipseIcon from '@/components/icons/Shape-ellipse'
import ShapeLineIcon from '@/components/icons/Shape-line'
import SortingIcon from '@/components/icons/Sorting'
import StopIcon from '@/components/icons/Stop'
import ThicknessIcon from '@/components/icons/Thickness'
import TimerIcon from '@/components/icons/Timer'
import ToolAdjustmentsIcon from '@/components/icons/Tool-adjustments'
import ToolBoxIcon from '@/components/icons/Tool-box'
import ToolFrameIcon from '@/components/icons/Tool-frame'
import ToolFrameFilledIcon from '@/components/icons/Tool-frame-filled'
import ToolMovingIcon from '@/components/icons/Tool-moving'
import ToolMovingFilledIcon from '@/components/icons/Tool-moving-filled'
import ToolShapeIcon from '@/components/icons/Tool-shape'
import ToolShapeFilledIcon from '@/components/icons/Tool-shape-filled'
import ToyotaIcon from '@/components/icons/Toyota'
import TrashIcon from '@/components/icons/Trash'
import UndoIcon from '@/components/icons/Undo'
import ZoomInIcon from '@/components/icons/Zoom-in'

Vue.use(Vuetify, { directives: { Intersect } });

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        accent: '#82B1FF',
        error: '#EF5844',
        info: '#336DD1',
        primary: '#336DD1',
        secondary: '#4D5F7A',
      },
    },
  },
  icons: {
    values: {
      '5': {
        component: FiveIcon,
      },
      '9': {
        component: NineIcon,
      },
      '24': {
        component: TwentyFourIcon,
      },
      '48': {
        component: FortyEightIcon,
      },
      'arrow-down': { component: ArrowDownIcon },
      'arrow-up': { component: ArrowUpIcon },
      'brightness': { component: BrightnessIcon },
      'car': {
        component: CarIcon,
      },
      'car-danger': {
        component: CarDangerIcon,
      },
      'car-partial': {
        component: CarPartialIcon,
      },
      'check': { component: CheckIcon },
      'chevrolet': {
        component: ChevroletIcon,
      },
      'chevron-down': { component: ChevronDownIcon },
      'chevron-left': { component: ChevronLeftIcon },
      'chevron-left-filled': { component: ChevronLeftFilledIcon },
      'chevron-right': { component: ChevronRightIcon },
      'chevron-right-filled': { component: ChevronRightFilledIcon },
      'chevron-up': { component: ChevronUpIcon },
      'autonomous': {
        component: AutonomousIcon,
      },
      'color-swatch': { component: ColorSwatchIcon },
      'comparison': {
        component: ComparisonIcon,
      },
      'compare': {
        component: CompareIcon,
      },
      'clipboard': {
        component: Clipboard,
      },
      'contrast': { component: ContrastIcon },
      'crop': {
        component: CropIcon,
      },
      'danger': {
        component: DangerIcon,
      },
      'download': {
        component: DownloadIcon,
      },
      'edit': {
        component: EditIcon,
      },
      'eye': {
        component: EyeIcon,
      },
      'eye-close': {
        component: EyeCloseIcon,
      },
      'flag': {
        component: FlagIcon,
      },
      'floppy': {
        component: FloppyIcon,
      },
      'ford': {
        component: FordIcon,
      },
      'link': { component: LinkIcon },
      'message': {
        component: MessageIcon,
      },
      'minus': {
        component: MinusIcon,
      },
      'more': {
        component: MoreIcon,
      },
      'next': { component: NextIcon },
      'open-window': {
        component: OpenWindowIcon,
      },
      'pencil': { component: PencilIcon },
      'picture': { component: PictureIcon },
      'plus': {
        component: PlusIcon,
      },
      'race': {
        component: RaceIcon,
      },
      'refresh': {
        component: RefreshIcon,
      },
      'refresh-2': {
        component: RefreshTwoIcon,
      },
      'report': {
        component: ReportIcon,
      },
      'rotate': {
        component: RotateIcon,
      },
      'save': {
        component: SaveIcon,
      },
      'search': {
        component: SearchIcon,
      },
      'settings': {
        component: SettingsIcon,
      },
      'shape-arrow': { component: ShapeArrowIcon },
      'shape-dot': { component: ShapeDotIcon },
      'shape-ellipse': { component: ShapeEllipseIcon },
      'shape-line': { component: ShapeLineIcon },
      'sorting': {
        component: SortingIcon,
      },
      'stop': {
        component: StopIcon,
      },
      'thickness': { component: ThicknessIcon },
      'timer': {
        component: TimerIcon,
      },

      'tool-adjustments': { component: ToolAdjustmentsIcon },
      'tool-box': { component: ToolBoxIcon },
      'tool-frame': { component: ToolFrameIcon },
      'tool-frame-filled': { component: ToolFrameFilledIcon },
      'tool-moving': { component: ToolMovingIcon },
      'tool-moving-filled': { component: ToolMovingFilledIcon },
      'tool-shape': { component: ToolShapeIcon },
      'tool-shape-filled': { component: ToolShapeFilledIcon },
      'toyota': {
        component: ToyotaIcon,
      },
      'trash': {
        component: TrashIcon,
      },
      'undo': { component: UndoIcon },
      'zoom-in': { component: ZoomInIcon },
    },
  },
});
